<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm-4.876-8.263 3.142 3.142 1.047-1.047 5.76-5.761a.74.74 0 1 0-1.047-1.047l-5.759 5.759-2.096-2.094a.74.74 0 0 0-1.047 1.048z" fill="#59CA9D"/>
  </svg>
</template>

<script>
export default {
  name: "DocumentationCompleteIcon"
}
</script>